import { Routes } from '@angular/router';
import { PAGE_ROUTES } from '@shared/core-data';
import { completeOnBoardingGuard } from '@guards/complete-on-boarding.guard';
import { createAccountGuard } from '@guards/create-account.guard';
import { authGuard, initializationGuard } from '@shared/auth';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: PAGE_ROUTES.CREATE_ACCOUNT,
    canActivate: [initializationGuard, createAccountGuard],
    loadChildren: () =>
      import('@create-account/onboarding').then((m) => m.OnboardingModule),
  },
  {
    path: PAGE_ROUTES.AUTH,
    canActivate: [authGuard],
    loadChildren: () =>
      import('@pages/not-auth/not-auth.module').then((m) => m.NotAuthModule),
  },
  {
    path: PAGE_ROUTES.WAIT,
    canActivate: [initializationGuard, completeOnBoardingGuard],
    loadChildren: () =>
      import('@wait-approve').then((m) => m.WaitApproveModule),
  },
  {
    path: PAGE_ROUTES.SUPPORT,
    loadChildren: () => import('@support').then((m) => m.SupportModule),
  },
  {
    path: PAGE_ROUTES.LOADING,
    loadComponent: () =>
      import('@page-status/loading').then((m) => m.LoadingComponent),
  },

  { path: '**', redirectTo: '', pathMatch: 'full' },
];
